import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Grid from '../image/grid-bs.png'
import SolarPanel from '../image/solarpanel-bs.png'
import Load from '../image/load-bs.png'
import Inverter from '../image/inverter-bs.png'
import colors from "../colour";
import { keyframes } from '@emotion/react';
import { buildingDataAPI, solarDataAPI, gridwithEcosDataAPI, batteryPowerDataAPI, BatterySOCDataAPI, } from "../api/meter";
import { sm_gridDataAPI, sm_solarDataAPI, sm_loadDataAPI } from "../api/smartmeter";
import moment from "moment";

// Animation
// Arrow animation for load
const moveArrowLeftToRight_LOAD = keyframes`
  0% {
    transform: translateX(-11vw); /* Start at the left of the horizontal line */
    opacity: 1;
  }
  100% {
    transform: translateX(0vw); /* Move to the right of the horizontal line */
    opacity: 1;
  }
`;

const colorloadingload = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg2};
    transform: translateX(-11vw);
  }
  100% {
    width: 11vw;
    background-color: ${colors.bsg2};
    transform: translateX(0vw);
  }
`;

// Arrow animation for solarpanel
const moveArrowLShape = keyframes`
  0% {
    transform: translate(0, 0) rotate(90deg);  /* Facing down */
    opacity: 1;
  }
  40% {
    transform: translate(0, 9.5vh) rotate(90deg);  /* Still facing down */
  }
  41% {
    transform: translate(0, 9.5vh) rotate(0deg);  /* Rotate to face right */
  }
  100% {
    transform: translate(9.5vw, 9.5vh) rotate(0deg);  /* Moving right */
    opacity: 1;
  }
`;
const colorloadingverticalsolar = keyframes`
  0% {
    height: 0vh;
    background-color: ${colors.bsg2};
  }
  43% {
    height: 9.5vh;
    background-color: ${colors.bsg2};
  }
  100% {
    height: 9.5vh;
    background-color: ${colors.bsg2};
  }
`;

const colorloadinghorizontalsolar = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg2};
  }
  40% {
    width: 0vw;
    background-color: ${colors.bsg2};
  }
  98% {
    width: 9.2vw;
    background-color: ${colors.bsg2};
  }
  100% {
    width: 10vw;
    background-color: ${colors.bsg2};
  }
`;


// Arrow animation for grid
const moveArrowLeftToRight = keyframes`
  0% {
    transform: translateX(1vw); // start at left
  }
  100% {
    transform: translateX(18.7vw); // distance to move
  }
`;

const moveArrowRightToLeft = keyframes`
  0% {
    transform: translateX(18.7vw); // start at right
  }
  100% {
    transform: translateX(1vw); // move back to left
  }
`;

const colorloadingleftgrid = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg2};
  }
  100% {
    width: 18vw;
    background-color: ${colors.bsg2};

  }
`;
const colorloadingrightgrid = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg1};
  }
  100% {
    width: 17.9vw;
    background-color: ${colors.bsg1};

  }
`;

// Arrow animation for battery
const moveArrowReverseLShape = keyframes`
  0% {
    transform: translate(0, 0) rotate(270deg);  // Start at the bottom of the vertical line
    opacity: 1;
  }
  40% {
    transform: translate(0, -9.5vh) rotate(270deg);  // Move up the vertical line
  }
  41% {
    transform: translate(0, -9.5vh) ;  // Rotate the arrow after reaching the top
  }
  100% {
    transform: translate(9.5vw, -9.5vh);  // Move to the end of the horizontal line
    opacity: 1;
  }
`;
const moveArrowMirrorLShape = keyframes`
  0% {
    transform: translate(9.5vw, -9.5vh) rotate(180deg);  /* Start at the right end of horizontal line */
    opacity: 1;
  }
  40% {
    transform: translate(0, -9.5vh) rotate(180deg);  /* Move left along horizontal line */
  }
  41% {
    transform: translate(0, -9.5vh) rotate(90deg);  /* Rotate arrow before moving down */
  }
  100% {
    transform: translate(0, 0) rotate(90deg);  /* Move down vertical line */
    opacity: 1;
  }
`;
const colorShrinkHorizontalleft = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg1};
  }
  40% {
    width: 0vw;
    background-color: ${colors.bsg1};
  }
  98% {
    width: 9.5vw;
    background-color: ${colors.bsg1};
  }
  100% {
    width: 10vw;
    background-color: ${colors.bsg1};
  }
`;
const colorShrinkVerticalleft = keyframes`
 0% {
    height: 0vh;
    background-color: ${colors.bsg1};
  }
  43% {
    height: 9.5vh;
    background-color: ${colors.bsg1};
  }
  100% {
    height: 9.5vh;
    background-color: ${colors.bsg1};
  }
`;
const colorShrinkHorizontalright = keyframes`
  0% {
    width: 0vw;
    background-color: ${colors.bsg2};
  }
  40% {
    width: 9.95vw;
    background-color: ${colors.bsg2};
  }
  100% {
    width: 9.95vw;
    background-color: ${colors.bsg2};
  }
`;

const colorShrinkVerticalright = keyframes`
  0% {
    height: 0vh;
    background-color: ${colors.bsg2};
  }
  43% {
    height: 0vh;
    background-color: ${colors.bsg2};
  }
  100% {
    height: 9.5vh;
    background-color: ${colors.bsg2};
  }
`;


const breatheLight = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 0.2vw 0.1vw rgb(191, 255, 225);
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
    box-shadow: 0 0 0.8vw 0.2vw rgb(0, 233, 241);
  }
`;

const colorPulse = keyframes`
  0% { border-color: ${colors.bs6}; }
  50% { border-color: #4dabf5; } // Example alternate color (light blue)
  100% { border-color: ${colors.bs6}; }
`;

//aniamtion for battery fill
const pulse = keyframes`
  0% {
    background-position: 0% 0%;
    opacity: 0.85;
  }
  10% {
    background-position: 0% 10%;
    opacity: 0.88;
  }
  20% {
    background-position: 0% 20%;
    opacity: 0.91;
  }
  30% {
    background-position: 0% 30%;
    opacity: 0.94;
  }
  40% {
    background-position: 0% 40%;
    opacity: 0.97;
  }
  50% {
    background-position: 0% 50%;
    opacity: 1;
  }
  60% {
    background-position: 0% 60%;
    opacity: 0.97;
  }
  70% {
    background-position: 0% 70%;
    opacity: 0.94;
  }
  80% {
    background-position: 0% 80%;
    opacity: 0.91;
  }
  90% {
    background-position: 0% 90%;
    opacity: 0.88;
  }
  100% {
    background-position: 0% 100%;
    opacity: 0.85;
  }
`;

//animation for solar panel
const pulseGlow = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 1vw 1vh rgba(255, 209, 3, 0.5);
    background: rgba(212, 159, 97, 0.19);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.1);
  }
`;

//animation for charging logo pulse
const charging = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.7;
    text-shadow: 0 0 0.2vw #ff9800;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
    text-shadow: 0 0 0.4vw rgb(255, 127, 7);
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
    text-shadow: 0 0 0.2vw  #ff9800;
  }
`;

// animation for charing logo flash
const flash = keyframes`
  0% {
    transform: scale(1);  
    opacity: 1;
  }
  20% {
    transform: scale(1.4);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const SLD = ({ hasSmartMeter, clientId, selectedDate = new Date() }) => {
  const [buildingLoad, setBuildingLoad] = useState([]);
  const [solarData, setSolarData] = useState([]);
  const [gridWithoutEcosData, setGridWithoutEcosData] = useState([]);
  const [batteryPowerData, setBatteryPowerData] = useState([]);
  const [batterySOCData, setBatterySOCData] = useState([]);
  const [smsolar, setsmsolar] = useState([]);
  const [smload, setsmload] = useState([]);
  const [smgrid, setsmgrid] = useState([]);
  const today = moment().format("YYYY-MM-DD");
  const interval = 900;


  useEffect(() => {
    if (!clientId) return;

    let intervalId;

    const fetchData = async () => {
      try {
        if (hasSmartMeter) {
          const [
            sm_loadData,
            sm_solarData,
            sm_gridData,
          ] = await Promise.all([
            sm_loadDataAPI(clientId, today, interval),
            sm_solarDataAPI(clientId, today, interval),
            sm_gridDataAPI(clientId, today, interval),
          ]);

          setsmload(sm_loadData?.data || []);
          setsmsolar(sm_solarData?.data || []);
          setsmgrid(sm_gridData?.data || []);
        } else {
          const [
            buildingDataResp,
            solarDataResp,
            gridWithoutEcosResp,
            batteryPowerResp,
            batterySOCResp,
          ] = await Promise.all([
            buildingDataAPI(clientId, today, interval),
            solarDataAPI(clientId, today, interval),
            gridwithEcosDataAPI(clientId, today, interval),
            batteryPowerDataAPI(clientId, today, interval),
            BatterySOCDataAPI(clientId, today, interval),
          ]);

          setBuildingLoad(buildingDataResp?.data || []);
          setSolarData(solarDataResp?.data || []);
          setGridWithoutEcosData(gridWithoutEcosResp?.data || []);
          setBatteryPowerData(batteryPowerResp?.data || []);
          setBatterySOCData(batterySOCResp?.data || []);

        }
      } catch (error) {
        console.error("❌ Error fetching data:", error?.response?.data || error.message);
      }
    };

    fetchData(); // Fetch immediately on mount/update

    intervalId = setInterval(fetchData, interval * 1000); // Refresh at set interval

    return () => clearInterval(intervalId); // Cleanup
  }, [clientId, hasSmartMeter, interval, today]);

  //to get the latest valid data
  const getLatestValidData = (
    dataArray,
    valueField,
    timeField = 'recorded_at',
    validWithinMinutes = 25
  ) => {
    if (!Array.isArray(dataArray)) return null;

    const now = moment();
    const fromTime = moment().subtract(validWithinMinutes, 'minutes');

    const validData = dataArray.filter(item =>
      item?.[valueField] != null &&
      item?.[timeField] &&
      moment(item[timeField]).isBetween(fromTime, now, null, '[]')
    );

    return validData.length > 0
      ? validData[validData.length - 1]
      : null;
  };




  // The data after validation
  const lastValidSOC = getLatestValidData(batterySOCData, 'battery_soc_value', 'recorded_at');
  const lastValidBuildingLoad = getLatestValidData(buildingLoad, 'building_load', 'recorded_at');
  const lastValidSolarData = getLatestValidData(solarData, 'solar_value', 'recorded_at'); // use actual field name
  const lastValidGridWithoutEcos = getLatestValidData(gridWithoutEcosData, 'grid_value', 'recorded_at'); // replace 'grid_value'
  const lastValidBatteryPower = getLatestValidData(batteryPowerData, 'battery_power', 'recorded_at'); // replace with actual field

  // Check if the values are positive
  const isPositiveGridWithoutEcos = lastValidGridWithoutEcos && lastValidGridWithoutEcos.grid_value >= 0;
  const isPositiveBatteryPower = lastValidBatteryPower && lastValidBatteryPower.battery_power <= 0;
  const isPositiveSolar = lastValidSolarData && lastValidSolarData.solar_value >= 0;
  const isPositiveload = lastValidBuildingLoad && lastValidBuildingLoad.building_load >= 0;
  //get the latest timestamp for non meter user
  const solarTime = lastValidSolarData?.recorded_at ?? null;
  const loadTime = lastValidBuildingLoad?.recorded_at ?? null;
  const gridTime = lastValidGridWithoutEcos?.recorded_at ?? null;
  const batteryTime = lastValidBatteryPower?.recorded_at ?? null;

  //smartmeter validation
  //smartmeter solar data
  const lastValidSMSolar = Array.isArray(smsolar)
    ? smsolar.reduce(
      (acc, meter) => {
        if (!Array.isArray(meter.data)) return acc;

        const reversed = [...meter.data].reverse();
        const lastValid = reversed.find(
          item => item?.total_active_power_kw != null
        );

        if (!lastValid) return acc;

        return {
          value: acc.value + lastValid.total_active_power_kw,
          // keep the latest timestamp among meters
          time:
            !acc.time || new Date(lastValid.recorded_at) > new Date(acc.time)
              ? lastValid.recorded_at
              : acc.time
        };
      },
      { value: 0, time: null }
    )
    : { value: 0, time: null };

  const lastValidSMSolarData = lastValidSMSolar.value;
  const lastValidSMSolarTime = lastValidSMSolar.time;

  const isSMPositiveSolar =
    lastValidSMSolarData != null && lastValidSMSolarData >= 0;


  //smartmeter load data
  const lastValidSMLoad = Array.isArray(smload)
    ? smload.reduceRight((found, item) => {
      // If already found, keep it
      if (found !== null) return found;

      // Skip invalid values
      if (item?.total_active_power_kw == null) return null;

      return {
        value: item.total_active_power_kw,
        time: item.recorded_at ?? null
      };
    }, null) ?? { value: 0, time: null }
    : { value: 0, time: null };

  const lastValidSMLoadData = lastValidSMLoad.value;
  const lastValidSMLoadTime = lastValidSMLoad.time;

  const isSMLoadPositive =
    lastValidSMLoadData != null && lastValidSMLoadData >= 0;


  //smartmeter grid data
  const lastValidSMGrid = Array.isArray(smgrid)
    ? smgrid.reduce(
      (acc, meter) => {
        if (!Array.isArray(meter.data)) return acc;

        const reversed = [...meter.data].reverse();
        const lastValid = reversed.find(
          item => item?.total_active_power_kw != null
        );

        if (!lastValid) return acc;

        return {
          value: acc.value + lastValid.total_active_power_kw,
          // keep the most recent timestamp
          time:
            !acc.time || new Date(lastValid.recorded_at) > new Date(acc.time)
              ? lastValid.recorded_at
              : acc.time
        };
      },
      { value: 0, time: null }
    )
    : { value: null, time: null };

  const lastValidSMGridData = lastValidSMGrid.value;
  const lastValidSMGridTime = lastValidSMGrid.time;

  const isSMPositiveGrid =
    lastValidSMGridData != null && lastValidSMGridData >= 0;

  const smartmeterormeter = hasSmartMeter ? lastValidSMGridData : isPositiveGridWithoutEcos;

  //batery animation design
  const clampedLevel = hasSmartMeter
    ? 0
    : Math.max(0, Math.min(100, lastValidSOC?.battery_soc_value ?? 0));

  const solarlight = hasSmartMeter ? lastValidSMSolarData : lastValidSolarData;


  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >

      {/* ---------------Inverter -------------------*/}
      <Box
        component="img"
        src={Inverter}
        alt="Inverter"
        sx={{
          width: "12%",
          height: "30%",
          objectFit: "cover",
          position: "absolute",
          top: "35%",
          right: "37%",
          zIndex: 2,
        }}
      />
      {/* ---------------SolarPanel-------------- */}
      <Box>
        <Box
          sx={{
            width: "15%",
            height: "13%",
            objectFit: "cover",
            position: "absolute",
            border: "0.3vh solid",
            borderColor: colors.bs6,
            top: "16.5%",
            left: "39%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            gap: "0.5vh",
            animation: `${colorPulse} 2s ease-in-out infinite`,
          }}
        >
          <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>Solar Generation : </Typography>
          {hasSmartMeter ? (
            <Typography sx={{ color: isSMPositiveSolar ? colors.g4 : colors.g1, fontSize: "0.7vw", fontWeight: 'bold' }}>
              {lastValidSMSolarData != null ? lastValidSMSolarData.toFixed(2) : "N/A"} kW
            </Typography>
          ) : (
            <Typography sx={{ color: isPositiveSolar ? colors.g4 : colors.g1, fontSize: "0.7vw", fontWeight: 'bold' }}>
              {lastValidSolarData?.solar_value != null ? lastValidSolarData.solar_value.toFixed(2) : "N/A"} kW
            </Typography>
          )}
          {hasSmartMeter ? (
            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {lastValidSMSolarTime
                ? `${new Date(lastValidSMSolarTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          ) : (
            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {solarTime
                ? `${new Date(solarTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          )}
        </Box>
        <Box
          component="img"
          src={SolarPanel}
          alt="SolarPanel"
          sx={{
            width: "9.6%",
            height: "20%",
            objectFit: "cover",
            position: "absolute",
            top: "12%",
            left: "28%",
          }}
        />
        <Box
          sx={{
            width: "1.95%",
            height: "3.6%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "15.6%",
            left: "34.3%",
            borderRadius: "50%",
            zIndex: 2,
            animation: solarlight ? `${pulseGlow} 2s infinite ease-in-out` : "",
          }}
        ></Box>
        {/* Vertical line (solar panel) */}
        <Box
          sx={{
            position: "absolute",
            width: "0.2vw",
            height: "9.5vh",
            backgroundColor: colors.bs6,
            top: "32.5%",
            left: "33%",
            zIndex: 1,
          }}
        />

        {/* Horizontal line */}
        <Box
          sx={{
            position: "absolute",
            width: "10vw",
            height: "0.3vh",
            backgroundColor: colors.bs6,
            top: "47%",
            left: "33%",
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "0.2vw",
            height: "9.5vh",
            animation: `${colorloadingverticalsolar} 3s infinite linear`,
            backgroundColor: colors.bs6,
            top: "32.5%",
            left: "33%",
            zIndex: 1,
          }}
        />


        {/* Horizontal line */}
        <Box
          sx={{
            position: "absolute",
            width: "10vw",
            height: "0.3vh",
            animation: `${colorloadinghorizontalsolar} 3s infinite linear`,
            backgroundColor: colors.bs6,
            top: "47%",
            left: "33%",
            zIndex: 1,
          }}
        />


        {/* Animated Arrow following L-path */}
        <Box
          sx={{
            position: "absolute",
            top: "calc(34.8% - 1vw)",  // Adjust vertical position (adjust this value for better centering)
            left: "calc(34.9% - 1.2vw)", // Adjust horizontal position for better centering
            backgroundColor: colors.bsf1,
            width: "0.4vw",
            height: "0.4vw",
            borderRadius: "100%",
            fontSize: "2vw",
            animation: ` ${breatheLight} 1.5s infinite ease-in-out,${moveArrowLShape} 3s infinite linear`,  // Adjusted duration to match the other arrow
            transformOrigin: "center center",  // Ensures rotation stays consistent
            zIndex: 2,
          }}
        />


      </Box>

      {/* ------------------Load-------------------- */}
      <Box>
        <Box
          sx={{
            width: "15%",
            height: "13%",
            objectFit: "cover",
            position: "absolute",
            border: "0.3vh solid",
            borderColor: colors.bs6,
            bottom: "25%",
            right: "4%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            gap: "0.5vh",
            animation: `${colorPulse} 2s ease-in-out infinite`,
          }}
        >
          <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>
            Actual Load :
          </Typography>
          {hasSmartMeter ? (
            <Typography
              sx={{
                color: isSMLoadPositive ? colors.g4 : colors.g1,
                fontSize: "0.7vw",
                fontWeight: "bold",
              }}
            >
              {lastValidSMLoadData != null
                ? lastValidSMLoadData.toFixed(2)
                : "N/A"}{" "}
              kW
            </Typography>
          ) : (
            <Typography
              sx={{
                color: isPositiveload ? colors.g4 : colors.g1,
                fontSize: "0.7vw",
                fontWeight: "bold",
              }}
            >
              {lastValidBuildingLoad?.building_load != null
                ? lastValidBuildingLoad.building_load.toFixed(2)
                : "N/A"}{" "}
              kW
            </Typography>

          )}
          {hasSmartMeter ? (

            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {lastValidSMLoadTime
                ? `${new Date(lastValidSMLoadTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          ) : (
            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {loadTime
                ? `${new Date(loadTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          )}




        </Box>
        <Box
          component="img"
          src={Load}
          alt="Load"
          sx={{
            width: "11%",
            height: "25%",
            objectFit: "cover",
            position: "absolute",
            top: "35%",
            right: "6%",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "11vw",
            height: "0.3vh",
            backgroundColor: colors.bs6,
            top: "50%",
            right: "18%",
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "11vw",
            height: "0.3vh",
            animation: `${colorloadingload} 3s infinite linear`,
            top: "50%",
            right: "18%",
            zIndex: 1,
          }}
        />
        {/*icon moves from left to right*/}
        <Box
          sx={{
            position: "absolute",
            top: "calc(50.4% - 0.25vw)",
            right: "18%",
            width: "0.4vw",
            height: "0.4vw",
            borderRadius: "100%",
            backgroundColor: colors.bsf1,
            animation: `${breatheLight} 1.5s infinite ease-in-out, ${moveArrowLeftToRight_LOAD} 3s infinite linear`,
            zIndex: 2,
          }}
        />

      </Box>

      {/* ------------------ Battery ----------------------*/}
      <Box>


        {hasSmartMeter ? (
          <Box
            sx={{
              width: "18%",
              height: "15%",
              objectFit: "cover",
              position: "absolute",
              border: "0.3vh solid",
              borderColor: colors.bs6,
              bottom: "15.5%",
              left: "39%",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              gap: "0.5vh",
              alignItems: "center",
              animation: `${colorPulse} 2s ease-in-out infinite`,
            }}
          >
            <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>
              Battery SOC:{" "}
              <Typography component="span" sx={{ color: colors.g1, fontWeight: 'bold', fontSize: "0.7vw" }}>
                N/A %
              </Typography>

            </Typography>


            <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>Battery Power : </Typography>
            <Typography sx={{ color: colors.g1, fontSize: "0.7vw", fontWeight: 'bold' }}>N/A kW</Typography>

          </Box>
        ) : (
          <Box
            sx={{
              width: "18%",
              height: "15%",
              objectFit: "cover",
              position: "absolute",
              border: "0.3vh solid",
              borderColor: colors.bs6,
              bottom: "15.5%",
              left: "39%",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              gap: "0.5vh",
              alignItems: "center",
              animation: `${colorPulse} 2s ease-in-out infinite`,
            }}
          >
            <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>
              Battery SOC:{" "}
              {lastValidSOC ? (
                <Typography component="span" sx={{ color: colors.f2, fontWeight: 'bold', fontSize: "0.7vw" }}>
                  {lastValidSOC.battery_soc_value.toFixed(0)}%
                </Typography>
              ) : (
                'N/A'
              )}
            </Typography>


            <Box sx={{ display: "flex", alignItems: "center", gap: "0.4vw" }}>
              <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>
                Battery Power :
              </Typography>

              <Typography
                sx={{
                  color: isPositiveBatteryPower ? colors.g1 : colors.g4,
                  fontSize: "0.7vw",
                  fontWeight: "bold"
                }}
              >
                {lastValidBatteryPower
                  ? lastValidBatteryPower.battery_power.toFixed(2)
                  : "N/A"}{" "}
                kW
              </Typography>
            </Box>

            {hasSmartMeter ? (
              <Typography
                sx={{
                  color: colors.bsf1,
                  fontSize: "0.6vw"
                }}
              >
              </Typography>
            ) : (
              <Typography
                sx={{
                  color: colors.bsf1,
                  fontSize: "0.6vw"
                }}
              >
                {batteryTime
                  ? `${new Date(batteryTime).toLocaleString()}`
                  : "Last update: N/A"}
              </Typography>
            )}
          </Box>
        )}

        {/* battery  */}
        <Box
          sx={{
            width: '3vw',
            height: '8vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            bottom: '16%',
            left: '30.5%',
          }}
        >
          {/* Battery Container */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              borderRadius: '15%', // was 1.5rem, approx 15% of height/width (tune as needed)
              bgcolor: '#3a3f47',
              boxShadow: 'inset 0 0 0.5vw rgb(134, 192, 184)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Battery Cap */}
            <Box
              sx={{
                position: 'absolute',
                top: '-8%', // was -15px, negative % relative to container height
                left: '30%', // center the cap horizontally (40px / 100px = 40%, adjust)
                width: '40%', // was 40px, 40% of container width
                height: '10%', // was 15px, 10% of container height
                bgcolor: 'rgb(155, 185, 181)',
                borderRadius: '15%', // radius scaled to container
              }}
            />

            {/* Battery Fill */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                height: `${clampedLevel}%`,
                background: 'linear-gradient(to bottom, rgb(235, 254, 255), rgb(41, 106, 180))',
                backgroundSize: '100% 200%', // important for movement
                backgroundRepeat: 'no-repeat',
                borderRadius: '0 0 0.6vw 0.6vw',
                transition: 'height 0.4s ease-in-out',
                opacity: 0.9,
                zIndex: 1,
                clipPath: 'url(#waveClip)',
                WebkitClipPath: 'url(#waveClip)',
                animation: `${pulse} 7s ease-in-out infinite`,
              }}
            />

            <svg width="0" height="0" style={{ position: 'absolute' }}>
              <defs>
                <clipPath id="waveClip" clipPathUnits="objectBoundingBox">
                  <path
                    d="
                      M0,0.25 
                      C0.1,0.15 0.2,0.35 0.3,0.25
                      C0.4,0.15 0.5,0.35 0.6,0.25
                      C0.7,0.15 0.8,0.35 0.9,0.25
                      C1,0.15 1,0 5,0
                      L1,1
                      L0,1
                      Z
          "
                  />
                </clipPath>
              </defs>
            </svg>

            {/* Lightning Bolt Icon */}
            <Typography
              sx={{
                position: 'relative',
                fontSize: '1vw', // Scaled for container
                color: '#ff9800',
                zIndex: 2,
                animation: `${charging} 1.5s ease-in-out infinite`,

                // Use ::after to trigger a flash every few seconds
                '&::after': {
                  content: `'⚡'`,
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  display: 'inline-block',
                  animation: `${flash} 3s ease-in-out infinite`,
                  color: '#fff176',
                  opacity: 0,
                  zIndex: -1,
                },
              }}
            >
              ⚡
            </Typography>
          </Box>
        </Box>

        {/* battery (from midway down to Inverter) */}
        <Box
          sx={{
            position: "absolute",
            width: "0.2vw",
            height: "9.5vh",
            backgroundColor: colors.bs6,
            bottom: "32.4%",
            left: "33%",
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "10vw",
            height: "0.3vh",
            backgroundColor: colors.bs6,
            bottom: "47%",
            left: "33%",
            zIndex: 1,
          }}
        />
        {/* Horizontal Line - starts from right to left */}
        {hasSmartMeter ? null : (
          <>
            <Box
              sx={{
                position: "absolute",
                bottom: "47%",
                ...(isPositiveBatteryPower
                  ? { left: "33%" }
                  : { right: "49.6%" }),
                width: "10vw",
                height: "0.3vh",
                animation: `${isPositiveBatteryPower ? colorShrinkHorizontalleft : colorShrinkHorizontalright} 3s infinite linear`,
                zIndex: 1,
              }}
            />

            <Box
              sx={{
                position: "absolute",
                ...(isPositiveBatteryPower
                  ? { bottom: "32.5%" }
                  : { top: "52.9%" }),
                zIndex: 1,
                left: "33%",
                width: "0.2vw",
                height: "9.5vh",
                animation: `${isPositiveBatteryPower ? colorShrinkVerticalleft : colorShrinkVerticalright} 3s infinite linear`,
              }}
            />

            <Box
              sx={{
                position: "absolute",
                bottom: "calc(34.6% - 1vw)",
                left: "calc(34.9% - 1.2vw)",
                width: "0.4vw",
                height: "0.4vw",
                borderRadius: "100%",
                backgroundColor: isPositiveBatteryPower ? colors.bsg1 : colors.bsf1,
                fontSize: "2vw",
                animation: `
          ${breatheLight} 1.5s infinite ease-in-out,
          ${isPositiveBatteryPower ? moveArrowReverseLShape : moveArrowMirrorLShape} 3s infinite linear`,
                transformOrigin: "center center",
                zIndex: 2,
              }}
            />
          </>
        )}

      </Box>

      {/* --------------------GRID ----------------------*/}
      <Box>
        <Box
          sx={{
            width: "15%",
            height: "13%",
            objectFit: "cover",
            position: "absolute",
            border: "0.3vh solid",
            borderColor: colors.bs6,
            bottom: "25%",
            left: "6.5%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            gap: "0.5vh",
            animation: `${colorPulse} 2s ease-in-out infinite`,
          }}
        >
          <Typography sx={{ color: colors.bsf1, fontSize: "0.7vw" }}>Incoming Grid : </Typography>
          {(hasSmartMeter ? (
            <Typography sx={{ color: isSMPositiveGrid ? colors.g4 : colors.g1, fontSize: "0.7vw", fontWeight: 'bold' }}>{lastValidSMGridData != null ? lastValidSMGridData.toFixed(2) : "N/A"} kW</Typography>

          ) : (
            <Typography sx={{ color: isPositiveGridWithoutEcos ? colors.g4 : colors.g1, fontSize: "0.7vw", fontWeight: 'bold' }}>{lastValidGridWithoutEcos?.grid_value != null ? lastValidGridWithoutEcos.grid_value.toFixed(2) : "N/A"} kW</Typography>
          ))}
          {hasSmartMeter ? (
            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {lastValidSMGridTime
                ? `${new Date(lastValidSMGridTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          ) : (
            <Typography
              sx={{
                color: colors.bsf1,
                fontSize: "0.6vw"
              }}
            >
              {gridTime
                ? `${new Date(gridTime).toLocaleString()}`
                : "Last update: N/A"}
            </Typography>
          )}
        </Box>

        <Box
          component="img"
          src={Grid}
          alt="Grid"
          sx={{
            width: "8%",
            height: "20%",
            objectFit: "cover",
            position: "absolute",
            top: "40%",
            left: "10%",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "18vw",
            height: "0.3vh",
            backgroundColor: colors.bs6,
            top: "50%",
            left: "19%",
            zIndex: 1,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "18vw",
            height: "0.3vh",
            animation: `${smartmeterormeter ? colorloadingleftgrid : colorloadingrightgrid} 3s infinite linear`,
            top: "50%",
            ...(smartmeterormeter
              ? { left: "19%" }
              : { right: "49.6%" }),
            zIndex: 1,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: "calc(52.5% - 1vw)",
            left: "calc(16% + 0.5vw)", // <- Fix this base position
            width: "0.4vw",
            height: "0.4vw",
            borderRadius: "100%",
            backgroundColor: smartmeterormeter ? colors.bsf1 : colors.bsg1,
            fontSize: "2vw",
            animation: `
                        ${breatheLight} 1.5s infinite ease-in-out,
                        ${smartmeterormeter ? moveArrowLeftToRight : moveArrowRightToLeft} 3s infinite linear
                        `,
            zIndex: 2,
          }}
        />




      </Box>

    </Box>


  );
};

export default SLD;
